import React from "react";

const LOGO_SRC = "/hinton-logo.webp?v=2";

// Official Hinton Hygiene "H" logomark
export const LogoMark = ({ size = 34, className = "" }) => (
  <img src={LOGO_SRC} alt="Hinton Hygiene" width={size} height={size} className={className} style={{ objectFit: "contain", borderRadius: Math.round(size * 0.28) }} />
);

export const Logo = ({ compact = false, className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <LogoMark size={compact ? 30 : 38} />
    {!compact && (
      <div className="leading-tight">
        <div className="font-display text-[17px] font-bold text-[color:var(--hh-ink)]">
          Hinton Hygiene
        </div>
        <div className="text-[10px] font-medium uppercase tracking-[0.14em] text-[color:var(--hh-amber-600)]">
          Customer Portal
        </div>
      </div>
    )}
  </div>
);

export default Logo;
